export default __webpack_public_path__ + "4585c93819279bdcb0ccf9289b3d07af.png";